import { render, staticRenderFns } from "./TNC.vue?vue&type=template&id=1e6ee0b2&scoped=true&"
import script from "./TNC.vue?vue&type=script&lang=js&"
export * from "./TNC.vue?vue&type=script&lang=js&"
import style0 from "./TNC.vue?vue&type=style&index=0&id=1e6ee0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6ee0b2",
  null
  
)

export default component.exports